export const registrationMicrocopy = {
  title: "training.registration",
  type: "training.registration.type",
  cost: "training.registration.cost",
  date: "training.registration.date",
  warningTitle: "training.registration.warning.popup.title",
  warningDescription: "training.registration.warning.popup.description",
  warningCancel: "training.registration.warning.popup.cancel.btn",
  warningClose: "training.registration.warning.popup.close.btn",
  emailLabel: "training.emailTrainingLabel",
  emailStartDate: "training.emailStartDateLabel",
  emailTerms: "training.emailTermsOfUseLabel",
  emailConsent: "training.emailDataConsentLabel"
} as const;
